// REACT IMPORTS
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

// COMPONENTS
import { SubmitMusicModal } from "../components/SubmitMusicModal";
import { SocialLinks } from "../components/SocialLinks";
import { ContactForm } from "../components/ContactForm";
import { RecommendSongModal } from "../components/RecommendSongModal";

// STYLES
import "../styles/Toolbar.css";
import {
  Home,
  User,
  Mail,
  Globe,
  Smartphone,
  TabletSmartphone, Music2,
  SquarePlay,
} from "lucide-react";

const augioLogo = "/brand_marks/Augio_G_Avatar_with_tm.png";

export const Toolbar = () => {
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);
  const [isRecommendOpen, setIsRecommendOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isSocialOpen, setIsSocialOpen] = useState(false);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const handleMobileLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isMobileMenuOpen]);

  return (
    <nav className="navbar">
      <div className="nav-brand">
        <Link
          to="/"
          className="nav-brand-link"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          <img className="toolbar-logo" src={augioLogo} alt="Augio Logo" />
          <h1 className="toolbar-augio">AUGIO</h1>
        </Link>
      </div>

      <div className="nav-links desktop-only">
        <Link to="/" className="nav-link">
          <Home size={14} strokeWidth={2.5} />
          Home
        </Link>

        <Link to="/about" className="nav-link">
          <User size={14} strokeWidth={2.5} />
          About
        </Link>

        <a
          href="#"
          className="nav-link"
          onClick={(e) => {
            e.preventDefault();
            setIsContactModalOpen(true);
          }}
        >
          <Mail size={14} strokeWidth={2.5} />
          Contact
        </a>

        <a
          href="#"
          className="nav-link"
          onClick={(e) => {
            e.preventDefault();
            setIsSocialOpen(true);
          }}
        >
          <Globe size={14} strokeWidth={2.5} />
          Social
        </a>
        <a
          className="nav-link"
          href="https://apps.apple.com/us/app/augio-music-discovery/id6736578132"
          target="_blank"
          rel="noopener noreferrer"
        >
          <TabletSmartphone size={14} strokeWidth={2.5} />
          App
        </a>
      </div>

      <div className="nav-actions">
        <button
          className="toolbar-btn btn-submit desktop-only"
          onClick={() => setIsSubmitModalOpen(true)}
        >
          <Music2 size="1.5rem" />
        </button>
        <button
          className="toolbar-btn btn-recommend desktop-only"
          onClick={() => setIsRecommendOpen(true)}
        >
          <SquarePlay size="1.5rem" />
        </button>

        <a
          href="https://apps.apple.com/us/app/augio-music-discovery/id6736578132"
          target="_blank"
          rel="noopener noreferrer"
          className="app-link"
        >
          <TabletSmartphone className="app-link-icon" size={22} />
        </a>

        <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={26} />}
        </button>
      </div>
      <div className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
        <div className="mobile-menu-links">
          <Link
            to="/"
            className="mobile-nav-link"
            onClick={handleMobileLinkClick}
          >
            Home
          </Link>
          <Link
            to="/about"
            className="mobile-nav-link"
            onClick={handleMobileLinkClick}
          >
            About
          </Link>
          <a
            href="#"
            className="mobile-nav-link"
            onClick={(e) => {
              e.preventDefault();
              setIsContactModalOpen(true);
              handleMobileLinkClick();
            }}
          >
            Contact
          </a>
          <a
            href="#"
            className="mobile-nav-link"
            onClick={(e) => {
              e.preventDefault();
              setIsSocialOpen(true);
              handleMobileLinkClick();
            }}
          >
            Social
          </a>

          <button
            className="toolbar-btn mobile-btn btn-submit"
            onClick={() => {
              setIsSubmitModalOpen(true);
              handleMobileLinkClick();
            }}
          >
            Submit Music
          </button>
          <button
            className="toolbar-btn mobile-btn btn-recommend"
            onClick={() => {
              setIsRecommendOpen(true);
              handleMobileLinkClick();
            }}
          >
            Recommend Music
          </button>
        </div>
      </div>

      <SubmitMusicModal
        isOpen={isSubmitModalOpen}
        onClose={() => setIsSubmitModalOpen(false)}
      />
      <ContactForm
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
      <SocialLinks
        isOpen={isSocialOpen}
        onClose={() => setIsSocialOpen(false)}
      />

      <RecommendSongModal
        isOpen={isRecommendOpen}
        onClose={() => setIsRecommendOpen(false)}
      />
    </nav>
  );
};
